import { getAuth } from "firebase/auth";
import { useEffect, useState } from "react";
import { app } from "../firebase/firebase-init";
import Loading from "../component/Loading";

const Login = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const auth = getAuth(app);

    auth.onAuthStateChanged((user) => {
      setIsLoggedIn(user);

      if (user) {
        window.location.href = "/admin";
      }
    });
  }, []);

  const [signingIn, setSigningIn] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData((prevFormData) => {
      return {
        ...prevFormData,
        [e.target.id]: e.target.value,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (signingIn) return;

    const verifyForm = () => {
      if (!formData.email || !formData.password) {
        alert("Please fill out all fields");
        return false;
      }

      return true;
    };

    if (!verifyForm()) return;

    try {
      setSigningIn(true);

      const { getAuth, signInWithEmailAndPassword } = await import(
        `firebase/auth`
      );
      const { app } = await import(`../firebase/firebase-init`);

      const auth = getAuth(app);

      const userCredential = await signInWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );

      console.log(userCredential.user);
    } catch (error) {
      const { code } = error;

      if (code === "auth/wrong-password") {
        alert("Wrong password.");
      } else if (code === "auth/user-not-found") {
        alert("User not found.");
      } else {
        alert("Something went wrong.");
      }
    } finally {
      setSigningIn(false);
    }
  };

  return (
    <>
      {isLoggedIn === false ? (
        <Loading />
      ) : !isLoggedIn ? (
        <form
          onSubmit={handleSubmit}
          className="container bg-light vh-100 d-flex align-items-center justify-content-center">
          <div
            style={{
              width: "350px",
              height: "350px",
            }}
            className={`d-flex flex-column gap-2 border bg-white m-auto p-4 rounded-1 shadow-sm`}>
            <h1 className="text-center">Login</h1>

            <div className="mb-3">
              <label
                htmlFor="email"
                className="form-label">
                Email address
              </label>

              <input
                onChange={handleChange}
                type="email"
                className="form-control"
                id="email"
                name="email"
                autoComplete="email"
                aria-describedby="email"
              />
            </div>

            <div className="mb-3">
              <label
                htmlFor="password"
                className="form-label">
                Password
              </label>

              <input
                onChange={handleChange}
                type="password"
                className="form-control"
                id="password"
                name="password"
                autoComplete="current-password"
                aria-describedby="password"
              />
            </div>

            <button
              disabled={signingIn}
              type="submit"
              className="btn btn-primary">
              {signingIn && (
                <div
                  className="spinner-border spinner-border-sm me-2"
                  role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
              Submit
            </button>
          </div>
        </form>
      ) : (
        `Logged in. Redirecting...`
      )}
    </>
  );
};

export default Login;
